module.exports = __webpack_public_path__ + "15e56e6a.png";